import Vue from 'vue'
import store from '../../vuex/Cookie_vuex'
var V = new Vue({store});

export default{

  //进行会话存储
  setlocalStorages:function(key,value,time){
    let data={ value: value, expirse: new Date(time).getTime() };
    window.localStorage.setItem(key,JSON.stringify(data))
  },

  saveLogining_user:function(data){
    sessionStorage.removeItem("store");
    sessionStorage.removeItem("token");//口令
    if(V.$store.state.u_id.length<=0){
      V.$store.commit({
        type:'changeUserInfor',
        u_token:data.token,
        u_id:data.id,
        name:data.name,
        phone:data.phone,
        photo:data.photo,
        sex:data.sex,
        email:data.email,
        signature:data.signature,
        shop_type:data.shop_type,
      });
    }else{
      V.$store.commit({
        type:'changeUserInfor_no_token',
        u_id:data.id,
        name:data.name,
        phone:data.phone,
        photo:data.photo,
        sex:data.sex,
        email:data.email,
        signature:data.signature,
        shop_type:data.shop_type,
      });
    }
    sessionStorage.setItem("token",V.$store.state.u_token)//口令
    sessionStorage.setItem("store",JSON.stringify(V.$store.state))
    //持久会话的存储
    window.localStorage.removeItem("store");
    window.localStorage.removeItem("token");
    let date = new Date().getTime();
    let daytime=86400000;//一天的时间，时间戳大小
    this.setlocalStorages("store",V.$store.state,date+daytime);//存储用户信息
    this.setlocalStorages("token",V.$store.state.u_token);//存储token
  },
 }



// WEBPACK FOOTER //
// ./src/assets/js/saveLogin.js